// extracted by mini-css-extract-plugin
export default {"header":"header_header__x8oeZ","navbar":"header_navbar__dWZRb","brand":"header_brand__PhTiu","links":"header_links__yE9z6","link":"header_link__Xkxsg"};